
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 56 56","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip-paper-logout)"}},[_c('path',{attrs:{"d":"M27.907 51.255H6.977A2.326 2.326 0 014.65 48.93V7.07a2.326 2.326 0 012.326-2.326h20.93a2.323 2.323 0 002.326-2.326A2.324 2.324 0 0027.907.092H6.977C3.13.092 0 3.222 0 7.07v41.86a6.985 6.985 0 006.977 6.977h20.93a2.323 2.323 0 002.326-2.325 2.323 2.323 0 00-2.326-2.326z"}}),_c('path',{attrs:{"d":"M55.31 26.345L41.17 12.39a2.325 2.325 0 10-3.265 3.312l10.105 9.972H20.933A2.323 2.323 0 0018.607 28a2.324 2.324 0 002.326 2.326H48.01l-10.105 9.972a2.325 2.325 0 003.265 3.312l14.14-13.954a2.324 2.324 0 000-3.311z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip-paper-logout"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h56v56H0z"}})])])])
          )
        }
      }
    